import Header from '../../Component/Header';
import { useState, useContext, useEffect } from 'react';
import { TextField, Button } from "@mui/material";
import { MyContext } from '../../Context';
import authentication from "../../utils/authentication";
import { api } from '../../service/Api';

function CadastroPergunta() {
    const [idPergunta, setIdPergunta] = useState(0);
    const [TextPergunta, setTextPergunta] = useState("");
    const [pergunta, setpergunta] = useState([]);
    const { question, setQuestion } = useContext(MyContext);
    const textFieldStyle = { margin: '8px 0' };
    const urlParams = new URLSearchParams(window.location.search);
    const tipo = urlParams.get("tipo");

    const config = {
        headers: {
            "x-access-token": authentication[222222],
        }
    };
    function inserePergunta(){
        let params = {
            "pergunta": TextPergunta,
            "usuario_cad": 5
        }
        api.post(`/satisfacao/criar_perguntas/`, params, config).then((response) => {
            if (response.data) {
                console.log(response.data);
            }
        }).catch((error) => {
            console.log(error);
            throw error;
        });
    }
    function listaPerguntas() {
        api.get(`/satisfacao/list_perguntas/${JSON.parse(localStorage.getItem('conexao')).cnes}/${tipo}`, config).then((response) => {
            if (response.data) {
                setpergunta(response.data);
                setTextPergunta("");
            }
        }).catch((error) => {
            console.log(error);
            throw error;
        });
    }

    useEffect(() => {
        listaPerguntas();
        localStorage.removeItem("tipo");
    }, [pergunta]);

    return (
        <>
            <Header />
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', width: '80%' }}>
                    <h1>Cadastro de Pesquisa de Satisfação</h1>
                    <TextField error={false} label='Digite aqui a pergunta de satisfação' id={TextPergunta !== "" ? "outlined-error" : ""} onChange={(e) => setTextPergunta(e.target.value)} style={textFieldStyle} placeholder='Digite aqui a pergunta' fullWidth />
                    <Button type='submit' color='primary' variant="contained" style={textFieldStyle} fullWidth onClick={() => inserePergunta()} >Entrar</Button>
                    
                    <h2>Perguntas Cadastradas</h2>
                    {pergunta &&
                        pergunta.map((item, index) => (
                            <div style={{display:'flex', flexDirection:'row'}}>
                                <p style={{marginRight:15}}><strong>{item.ID_PERGUNTA} - </strong></p>
                                <p>{item.PERGUNTA}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    );
}

export default CadastroPergunta;
